import React from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CalendarDays, Unplug } from "lucide-react";

export const CalendarStatus = ({ calendar, onChange }) => {
  if (!calendar) return null;

  const connect = async () => {
    try {
      const { data } = await api.get("/calendar/connect");
      window.location.assign(data.authorization_url);
    } catch (e) { toast.error(e?.response?.data?.detail || "Errore collegamento calendario"); }
  };
  const disconnect = async () => {
    await api.post("/calendar/disconnect");
    toast.success("Google Calendar scollegato");
    onChange();
  };

  if (!calendar.configured) {
    return (
      <span className="inline-flex items-center gap-2 text-xs text-[#6B6960] border border-dashed border-[#E2DFD6] rounded-full px-4 h-10" data-testid="calendar-not-configured" title="Aggiungi GOOGLE_CLIENT_ID e GOOGLE_CLIENT_SECRET in backend/.env">
        <CalendarDays size={14} /> Google Calendar: credenziali mancanti
      </span>
    );
  }
  if (calendar.connected && calendar.token_valid === false) {
    return (
      <Button onClick={connect} variant="outline" className="rounded-full border-red-700/40 text-red-800 bg-red-50" data-testid="calendar-reconnect" title="Il collegamento con Google è scaduto o è stato revocato">
        <CalendarDays size={16} className="mr-2" /> Calendario scollegato · Ricollega Google Calendar
      </Button>
    );
  }
  if (calendar.connected) {
    return (
      <span className="inline-flex items-center gap-2 text-xs border border-green-700/30 bg-green-50 text-green-800 rounded-full pl-4 pr-2 h-10" data-testid="calendar-connected" title="Arancione = soggiorno · Verde = laboratori">
        <CalendarDays size={14} /> Calendario: {calendar.email}
        <span className="inline-flex items-center gap-1 ml-1"><span className="w-2.5 h-2.5 rounded-full bg-[#F4511E]" /> soggiorno <span className="w-2.5 h-2.5 rounded-full bg-[#0B8043] ml-1" /> lab</span>
        <button type="button" onClick={disconnect} className="ml-1 p-1 hover:text-red-700" title="Scollega" data-testid="calendar-disconnect"><Unplug size={14} /></button>
      </span>
    );
  }
  return (
    <Button onClick={connect} variant="outline" className="rounded-full border-[#1A1A1A]/20" data-testid="calendar-connect">
      <CalendarDays size={16} className="mr-2" /> Collega Google Calendar
    </Button>
  );
};
